import { IssueCaseStatusCode } from '@gooduncles/gu-app-schema';
import { FC } from 'react';

import { CrmUnifiedRowData } from 'src/utils/crm/crm-data-util';

import CrmBoardTable from '../../CrmBoardTable';

import TableToolbar from './TableToolbar';

interface TableSectionProps {
  rowData: CrmUnifiedRowData[];
  isLoading: boolean;
  dateRange: [Date, Date];
  onDateRangeChange: (dates: [Date, Date]) => void;
  issueStatuses: IssueCaseStatusCode[];
  onIssueStatusesChange: (statuses: IssueCaseStatusCode[]) => void;
}

const TableSection: FC<TableSectionProps> = ({
  rowData,
  isLoading,
  dateRange,
  onDateRangeChange,
  issueStatuses,
  onIssueStatusesChange,
}) => {
  return (
    <>
      <TableToolbar
        dateRange={dateRange}
        onDateRangeChange={onDateRangeChange}
        issueStatuses={issueStatuses}
        onIssueStatusesChange={onIssueStatusesChange}
      />
      <CrmBoardTable rowData={rowData} isLoading={isLoading} />
    </>
  );
};

export default TableSection;
